import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import CategoryManagement from "../CategoryManagement/CategoryManagement";
import SubCategoryManagement from "../SubCategoryManagement/SubCategoryManagement";
import { storeCategoryServices } from "../../../../../APIServices/SitePilotManagement/StoreManagement/storeCategoryServices";
import TagManagement from "../TagsManagement/TagManagement";
import StoreProductList from "../StoreProductList/StoreProductList";

const TABS = [
  { key: "storeProducts", label: "Products" },
  { key: "category", label: "Category" },
  { key: "subCategory", label: "Sub Category" },
  { key: "tags", label: "Tags" },
];

const StoreProductManagement = () => {
  const [openModule, setOpenModule] = useState("storeProducts");
  const [storeCategories, setStoreCategories] = useState([]);

  const getActiveStoreCategoryList = async () => {
    const res = await storeCategoryServices.getStoreCategoryList("active");
    setStoreCategories(res?.data || []);
  };

  useEffect(() => {
    getActiveStoreCategoryList();
  }, []);

  const MODULES = {
    storeProducts: <StoreProductList storeCategories={storeCategories} />,
    category: <CategoryManagement getActiveStoreCategoryList={getActiveStoreCategoryList}/>,
    subCategory: <SubCategoryManagement storeCategories={storeCategories} />,
    tags: <TagManagement getActiveStoreCategoryList={getActiveStoreCategoryList} />,
  };

  return (
    <div className="h-100 d-flex flex-column w-100">
      <div className="bg-white border-bottom py-2 px-3">
        <div className="hstack justify-content-between">
          <h6 className="fw-semibold m-0">Product Management</h6>

          <div className="hstack gap-2">
            {TABS?.map(({ key, label }) => (
              <Button
                key={key}
                size="sm"
                variant={openModule === key ? "primary" : "outline-primary"}
                onClick={() => setOpenModule(key)}
              >
                {label}
              </Button>
            ))}
          </div>
        </div>
      </div>

      <div className="flex-grow-1 overflow-auto bg-light">
        {MODULES[openModule]}
      </div>
    </div>
  );
};

export default StoreProductManagement;
